import axios from 'axios';

export default class FeedService {
  constructor() {}

  getFeedByIds(ids, isDeleted?: any) {
    let url = 'api/connectome-feed/getByIds';
    if (isDeleted !== null && isDeleted !== undefined) url += '?isDeleted=' + isDeleted;
    return axios.post(url, ids);
  }

  getStock(stockCode: any) {
    return axios.post('api/connectome-feed/getStock', stockCode);
  }

  handleActivityLike(requestId, connectomeId, docId, liked, document?, isBookmarked?, isDeleted?) {
    const params = {
      requestId: 'requestId',
      connectomeId: connectomeId,
      docId: docId,
      liked: liked,
      isBookmarked: null,
      isDeleted: null,
      document: document,
    };
    return axios.put('api/connectome-feeds/activityLike', params);
  }

  handleActivityBookmark(requestId, connectomeId, docId, liked, isBookmarked, document?, isDeleted?) {
    const params = {
      requestId: 'requestId',
      connectomeId: connectomeId,
      docId: docId,
      liked: 0,
      isBookmarked: isBookmarked,
      isDeleted: null,
      document: document,
    };
    return axios.put('api/connectome-feeds/activityBookmark', params);
  }

  handleLikeFeed(requestId, connectomeId, docId, liked, isBookmarked, document?, isDeleted?) {
    const params = {
      requestId: 123123123,
      connectomeId: connectomeId,
      docId: docId,
      liked: liked,
      isBookmarked: isBookmarked,
      isDeleted: null,
      document: document,
      type: 'URL',
    };
    return axios.put('api/scrapboard-manager/like-feed', params);
  }

  handleHideFeed(requestId, connectomeId, docId, liked, isBookmarked, isDeleted, document?) {
    const params = {
      requestId: 'requestId',
      connectomeId: connectomeId,
      docId: docId,
      liked: 0,
      isBookmarked: null,
      isDeleted: isDeleted,
      document: document,
    };
    return axios.put('api/connectome-feeds/hideFeed', params);
  }

  getListDocumentByIds(connectomeId, docIds, requestId?, requireContent?) {
    const params = {
      requestId: requestId ? requestId : 'requestId',
      docIds: docIds,
      // page: 0,
      // size: 0,
      require_content: requireContent === undefined ? true : requireContent,
    };
    if (connectomeId?.length) {
      params['connectomeId'] = connectomeId;
    }
    return axios.post('api/connectome-feeds/getListDocumentByIds', params);
  }

  saveDocument(docIds) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/connectome-feeds/saveDocument', docIds)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
